export const FETCH_INITIAL_DATA = 'FETCH_INITIAL_DATA';

export function fetchInitialData() {
    return { type: FETCH_INITIAL_DATA };
}

